import InterviewBox, { InterviewBoxProps } from './InterviewBox.container';

export type InterviewBoxType = InterviewBoxProps;

export default InterviewBox;
